import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=64e03f00&scoped=true"
import script from "./sticky.vue?vue&type=script&lang=js"
export * from "./sticky.vue?vue&type=script&lang=js"
import style0 from "./sticky.vue?vue&type=style&index=0&id=64e03f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e03f00",
  null
  
)

export default component.exports